<footer class="main-footer">
  Copyright &copy; UNO {{ currentYear }}. All Rights Reserved
</footer>
